export const isCabinCrew = () => localStorage.getItem('isCabinCrew') === 'true';
